import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from'@angular/core';
import { HttpClient, HttpResponse } from'@angular/common/http';
import { NbDialogService } from'@nebular/theme';
import { CookieService } from'ngx-cookie-service';
import * as XLSX from 'xlsx';

import * as _ from'lodash';

@Component({
  selector:'app-report-reconciliation',
  templateUrl:'./report-reconciliation.component.html',
  styleUrls: ['./report-reconciliation.component.scss']
})
export class ReportReconciliationComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() info: {
    ORG_Company_ID: number,
    ORG_Store_ID: number;
  };

  
  //---------"與父組件共用，不可改位址------->---------------------
  @Input() ProductList: Array<any>;  //細項清單

  //-----------------------彈窗----------------------------

  modalRef = null;  //彈窗鉤子
  PdModalRef = null;  //彈窗鉤子

  @ViewChild('Modal') Modal :TemplateRef<any>
  @ViewChild('PdModal') PdModal :TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  year: number;
  month: number;

  YearList: any[] = [];
  MonthList: any[] = [
    { value: 1, content: '1月2月' },
    { value: 2, content: '3月4月' },
    { value: 3, content: '5月6月' },
    { value: 4, content: '7月8月' },
    { value: 5, content: '9月10月' },
    { value: 6, content: '11月12月' },
  ];

  selectedFile: File = null;
  fileName: string = '';
  uploadProgress: number = 0;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) 
  {
  }


  ngOnInit(): void {
  }


  ngAfterViewInit(){   
    this.onOpen()
  }

  onOpen() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
  
    // 生成年份列表
    this.YearList = Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - 4 + i;
      return { value: year, content: `${year}年` };
    });
  
    // 設置年份
    this.year = currentYear;
  
    // 設置月份
    if (currentMonth >= 3) {
      this.month = Math.ceil((currentMonth - 2) / 2);
    } else {
      this.year--;
      this.month = 6;
    }
  
    // 開啟彈窗
    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(() => {
      this.emitClose.emit(true);
    });
  }


  //上傳媒體申報檔
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }


  onUpdate() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      formData.append('ORG_Company_ID', this.info.ORG_Company_ID.toString());
      formData.append('ORG_Store_ID', this.info.ORG_Store_ID.toString());
      formData.append('year', this.year.toString());
      formData.append('month', this.month.toString());
  
      this.http.post<InvoiceLogReportREP>('api/InvoiceLogReport/UploadMediaReport', formData).subscribe({
        next: (response: InvoiceLogReportREP) => {
          if (response.DATA && response.DATA.LIST) {
            if (response.DATA.LIST.length > 0) {
              this.generateExcel(response.DATA.LIST);
              alert(`發現 ${response.DATA.LIST.length} 筆不匹配的發票`);
            } else {
              alert('所有發票都匹配');
            }
          } else {
            alert('處理失敗'+ response.RESULT);
          }
        },
        error: (error) => {
          alert('上傳過程中發生錯誤'+ error);
        }
      });
    } else {
      alert('沒有選擇文件');
    }
  }

  generateExcel(data: InvoiceLogDTO[]) {
    let sheetData = data.map(e => ({
      '發票號碼': e.InvoiceNumber,
      '訂單號碼': e.ORDNo || '',
      '結帳日期': e.CheckoutDateTime || '',
      '發票開立日期': e.CDate || '',
      '取消日期': e.CancelDateTime || '',
      '總金額': e.TotalCash || '',
      '不匹配原因': e.Mismatches ? e.Mismatches.join(', ') : '',
    }));
  
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(sheetData);
  
    XLSX.utils.book_append_sheet(wb, ws, "對帳結果");
  
    XLSX.writeFile(wb, '發票對帳結果.xlsx');
  }
}


interface InvoiceLogDTO {
  InvoiceNumber: string;
  ORDNo?: string;
  CreateDate?: string;
  CDate?: string;
  CheckoutDateTime?: string;
  CancelDateTime?: string;
  ORDKindName?: string;
  StoreName?: string;
  Cash?: number;
  ServiceFee?: number;
  ShippingFee?: number;
  TotalDiscountCash?: number;
  TotalCash?: number;
  Name?: string;
  Phone?: string;
  Status?: string;
  TaxType?: string;
  TaxAmount?: number;
  ORG_Company_ID?: number;
  ORG_Store_ID?: number;
  CreateBy?: string;
  POSName?: string;
  Mismatches?: string[];
}

interface InvoiceLogReportREP {
  DATA: {
    LIST: InvoiceLogDTO[];
    Total: number;
    TotalPages: number;
    Page: number;
    PerPage: number;
  };
  RESULT: string;
  Tag?: any;
}